import React from 'react';
import { Badge, Spinner } from '@economic/taco';
import { ValidationStatus } from './CompanyValidator';
import Note, { Type as NoteType } from './Note';
import { t } from '../../../../shared/components/l10n/l10n';
import './style.css';

interface Props {
    loading: boolean;
    validationStatus: ValidationStatus | undefined;
    companyName: string | undefined;
}

export default function ValidationInformation({ loading, validationStatus, companyName }: Props) {
    return (
        <>
            <div className="e_docs_onboarding__cvr_status h-12 leading-5 mb-5">
                {loading ? (
                    <Spinner delay={0} />
                ) : (
                    <div className="flex flex-col justify-center items-center space-y-4">
                        <div className="flex flex-row space-x-4">
                            <div>{t`EONBOARDING_CVRVALIDATION_CVRSTATUS`}</div>
                            <div>
                                <Badge
                                    color={
                                        validationStatus === ValidationStatus.Mismatch ||
                                        validationStatus === ValidationStatus.Valid
                                            ? 'green'
                                            : 'red'
                                    }>
                                    {validationStatus === ValidationStatus.Valid || validationStatus === ValidationStatus.Mismatch
                                        ? t`EONBOARDING_CVRVALIDATION_STATUS_VALID`
                                        : validationStatus === ValidationStatus.CvrInUse
                                        ? t`EONBOARDING_CVRVALIDATION_STATUS_INUSE`
                                        : t`EONBOARDING_CVRVALIDATION_STATUS_INVALID`}
                                </Badge>
                            </div>
                        </div>
                        <div className="flex flex-row space-x-4">
                            <div>{t`EONBOARDING_CVRVALIDATION_COMPANY_NAME`}</div>
                            <div>
                                <Badge color="blue">{companyName || '-'}</Badge>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {!loading && (
                <>
                    {validationStatus === ValidationStatus.Mismatch && (
                        <Note type={NoteType.Warning}>{t`EONBOARDING_CVRVALIDATION_STATUS_MISMATCH_DETAILS`}</Note>
                    )}
                    {validationStatus === ValidationStatus.CvrInUse && (
                        <Note type={NoteType.Error}>{t`EONBOARDING_CVRVALIDATION_STATUS_INUSE_DETAILS`}</Note>
                    )}
                    {validationStatus === ValidationStatus.CvrInvalid && (
                        <Note type={NoteType.Error}>{t`EONBOARDING_CVRVALIDATION_STATUS_INVALID_DETAILS`}</Note>
                    )}
                    {validationStatus === ValidationStatus.GlnInvalid && (
                        <Note type={NoteType.Error}>{t`EONBOARDING_CVRVALIDATION_STATUS_INVALID_GLN_DETAILS`}</Note>
                    )}
                    {validationStatus === ValidationStatus.NotEligibleForFreeGln && (
                        <Note type={NoteType.Error}>{t`EONBOARDING_CVRVALIDATION_STATUS_NOT_ELIGIBLE_FOR_FREE_GLN_DETAILS`}</Note>
                    )}
                </>
            )}
        </>
    );
}
